import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import TextSpan from './TextSpan';
import Typewriter from 'typewriter-effect'

const heroVariant = {
    init: {
        x: '100vw'
      },
      animate: {
        x: 0,
        transition: {
          duration:1.5,
        }
    }
}
//default   0a192f
const Home = () => {
  const sentence = "netPrime".split("");
  return (
    <div name='home' className='bg-[#0a192f] w-full h-screen'
    >
        {/* container */}
        <motion.div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'
            variants={heroVariant}
            initial='init'
            animate='animate'
        >
            <p className='text-pink-600 text-xl'>Hi, we are</p>
            <div>
              {sentence.map((letter, index)=>(
                <TextSpan key={index}>{letter}</TextSpan>
              ))}
            </div>
            <div className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>
              <Typewriter 
              options={{
                autoStart: true,
                loop: true,
                delay: 40,
                strings: ["IT development team."]
              }}
               />
            </div>
                
            <p className='text-[#8892b0] py-4 max-w-[700px]'>
            netPrime is your best tailor-made development agency, it puts its experts at your disposal to analyze your needs, develop your specific solution; web application, software, web platform.
            </p>
            <div>
                <Link to='work' className='text-white w-[160px] group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
                    View Work
                    <span className='group-hover:rotate-90 duration-300'>
                    <HiArrowNarrowRight className='ml-3 ' />
                    </span>
                </Link>
            </div>
        </motion.div>
    </div>
  )
}

export default Home